import { Dispatch, FC, FormEvent, SetStateAction } from 'react';
import styles from './ui.module.css';
type FormType = {
  handleSubmit: (e: FormEvent<HTMLFormElement>) => Promise<void>;
  setEmail: Dispatch<SetStateAction<string>>;
  setPassword: Dispatch<SetStateAction<string>>;
  email: string;
  password: string;
  buttonName: string;
};
const Form: FC<FormType> = ({
  handleSubmit,
  setPassword,
  setEmail,
  email,
  password,
  buttonName,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <label>
        Email:
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <label>
        Password:
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </label>
      <button type="submit" className={styles.submit_button}>
        {buttonName}
      </button>
    </form>
  );
};

export default Form;
